module.exports = __webpack_public_path__ + "static/media/play-white.74634cd8.svg";